import React from "react";
import { Controller, FormState } from "react-hook-form";
import type { Control } from "react-hook-form";
import { NativeSelectGema } from "../../../Themes/StyledElements";
import { Grid, Typography } from "@material-ui/core";

// Fonction pour accéder aux erreurs imbriquées
const getNestedError = (errors: any, name: string) => {
    // Convertir le nom du champ en tableau de clés
    // Par exemple, "spot.productNature" devient ["spot", "productNature"]
    // "works.[0].workCode" devient ["works", "0", "workCode"]
    const keys = name.replace(/\.\[/g, '.').replace(/\]/g, '').split('.');

    // Parcourir l'objet d'erreurs en suivant le chemin des clés
    let current = errors;
    for (const key of keys) {
        if (!current || !current[key]) {
            return undefined;
        }
        current = current[key];
    }

    return current.message;
};

export const FormSelectField = ({ label, name, control, disabled, formState, required, helperText, type, onChange, options }: { label: string, name: string, control: Control, disabled?: boolean, formState: FormState<any>, required?: boolean, helperText?: string, fullWidth?: boolean, type?: string, onChange?: () => void, options: any[] }) => {
    // Récupérer le message d'erreur pour ce champ
    const errorMessage = getNestedError(formState.errors, name);

    return (
        <Grid item container style={{ marginTop: '15px' }}>
            <Grid item xs={2}>
                {label} {required && <span style={{ color: 'red' }}>*</span>}
            </Grid>
            <Grid item xs={10} style={{ paddingRight: '20px' }}>
                <Controller
                    control={control}
                    name={name}
                    defaultValue=""
                    render={(field, state) => {
                        const { value, onChange: onChangeField } = field
                        const { invalid } = state

                        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                            onChangeField(event)
                            onChange?.()
                        }

                        return (
                            <NativeSelectGema
                                value={value || ""}
                                onChange={handleChange}
                                error={!!errorMessage}
                                disabled={disabled}
                                helperText={errorMessage}
                                required={required}
                                type={type}
                            >
                                {options.map((option) => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                    >
                                        &nbsp;&nbsp; {option.label}
                                    </option>
                                ))}
                            </NativeSelectGema>
                        )
                    }}
                />
                {!errorMessage && helperText && <Typography variant="caption" color="textSecondary">{helperText}</Typography>}
            </Grid>
        </Grid>
    )
}